
// import React, { useEffect, useState } from 'react';
// import Navbar from './Navbar';
// import Footer from './Footer';
// import SideMenu from './SideMenu';

// const SalesPage = () => {
//   const [requests, setRequests] = useState([]);
//   const [filteredRequests, setFilteredRequests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState('All');

//   useEffect(() => {
//     const fetchRequests = async () => {
//       try {
//         const response = await fetch('http://localhost:5000/get-requests');
//         const data = await response.json();
//         setRequests(data);
//         setFilteredRequests(data); // Initialize filteredRequests with all requests
//       } catch (error) {
//         console.error('Error fetching requests:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRequests();
//   }, []);

//   // Handle filtering
//   useEffect(() => {
//     if (filter === 'All') {
//       setFilteredRequests(requests);
//     } else {
//       setFilteredRequests(
//         requests.filter((request) => request.services.includes(filter))
//       );
//     }
//   }, [filter, requests]);

//   return (
//     <div>
//       <Navbar />
//       <div className="page-container">
//         <SideMenu />
//         <div className="content">
//           <h1>Client Requests</h1>

//           {/* Filter Dropdown */}
//           <div style={{ marginBottom: '20px' }}>
//             <label htmlFor="service-filter">Filter by Service: </label>
//             <select
//               id="service-filter"
//               value={filter}
//               onChange={(e) => setFilter(e.target.value)}
//             >
//               <option value="All">All</option>
//               <option value="AI Services">AI Services</option>
//               <option value="Web Development">Web Development</option>
//               <option value="App Development">App Development</option>
//               <option value="Cloud Services">Cloud Services</option>
//             </select>
//           </div>

//           {loading ? (
//             <p>Loading...</p>
//           ) : filteredRequests.length === 0 ? (
//             <p>No client requests match the selected filter.</p>
//           ) : (
//             <table>
//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>Company Name</th>
//                   <th>Email</th>
//                   <th>Phone</th>
//                   <th>Contact Method</th>
//                   <th>Services</th>
//                   <th>Description</th>
//                   <th>PDF</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredRequests.map((request, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{request.companyName}</td>
//                     <td>{request.email}</td>
//                     <td>{request.phone}</td>
//                     <td>{request.contactMethod}</td>
//                     <td>{request.services}</td>
//                     <td>{request.description}</td>
//                     <td>
//                       {request.pdfFile ? (
//                         <a
//                           href={`http://localhost:5000/uploads/${request.pdfFile}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           View PDF
//                         </a>
//                       ) : (
//                         'No PDF'
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default SalesPage;




// import React, { useEffect, useState } from 'react';
// import Navbar from './Navbar';
// import Footer from './Footer';
// import SideMenu from './SideMenu';

// const SalesPage = () => {
//   const [requests, setRequests] = useState([]);
//   const [filteredRequests, setFilteredRequests] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchRequests = async () => {
//       try {
//         const response = await fetch('http://localhost:5000/get-requests');
//         const data = await response.json();
//         setRequests(data);
//         setFilteredRequests(data); // Initialize filteredRequests with all requests
//       } catch (error) {
//         console.error('Error fetching requests:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRequests();
//   }, []);

//   // Filter logic based on column selection
//   const handleFilterChange = (e, column) => {
//     const value = e.target.value;
//     let filteredData = [...requests];

//     if (value !== 'All') {
//       filteredData = filteredData.filter((request) =>
//         column === 'services'
//           ? request.services.includes(value)
//           : request[column] === value
//       );
//     }

//     setFilteredRequests(filteredData);
//   };

//   return (
//     <div>
//       <Navbar />
//       <div className="page-container">
//         <SideMenu />
//         <div className="content">
//           <h1>Client Requests</h1>

//           {loading ? (
//             <p>Loading...</p>
//           ) : filteredRequests.length === 0 ? (
//             <p>No client requests match the selected filters.</p>
//           ) : (
//             <table>
//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>Company Name</th>
//                   <th>Email</th>
//                   <th>Phone</th>
//                   <th>
//                     Contact Method
//                     <select
//                       onChange={(e) => handleFilterChange(e, 'contactMethod')}
//                       style={{ marginLeft: '10px' }}
//                     >
//                       <option value="All">All</option>
//                       <option value="Phone">Phone</option>
//                       <option value="Email">Email</option>
//                     </select>
//                   </th>
//                   <th>
//                     Services
//                     <select
//                       onChange={(e) => handleFilterChange(e, 'services')}
//                       style={{ marginLeft: '10px' }}
//                     >
//                       <option value="All">All</option>
//                       <option value="AI Services">AI Services</option>
//                       <option value="Web Development">Web Development</option>
//                       <option value="App Development">App Development</option>
//                       <option value="Cloud Services">Cloud Services</option>
//                     </select>
//                   </th>
//                   <th>Description</th>
//                   <th>Requirements</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredRequests.map((request, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{request.companyName}</td>
//                     <td>{request.email}</td>
//                     <td>{request.phone}</td>
//                     <td>{request.contactMethod}</td>
//                     <td>{request.services}</td>
//                     <td>{request.description}</td>
//                     <td>
//                       {request.pdfFile ? (
//                         <a
//                           href={`http://localhost:5000/uploads/${request.pdfFile}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                             Req. PDF
//                         </a>
//                       ) : (
//                         'No PDF'
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default SalesPage;









// import React, { useEffect, useState } from 'react';
// import Navbar from './Navbar';
// import Footer from './Footer';
// import SideMenu from './SideMenu';

// const SalesPage = () => {
//   const [requests, setRequests] = useState([]);
//   const [filteredRequests, setFilteredRequests] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchRequests = async () => {
//       try {
//         const response = await fetch('http://localhost:5000/get-requests');
//         const data = await response.json();
//         setRequests(data);
//         setFilteredRequests(data); // Initialize filteredRequests with all requests
//       } catch (error) {
//         console.error('Error fetching requests:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRequests();
//   }, []);

//   // Filter logic based on column selection
//   const handleFilterChange = (e, column) => {
//     const value = e.target.value;
//     let filteredData = [...requests];

//     if (value !== 'All') {
//       filteredData = filteredData.filter((request) =>
//         column === 'services'
//           ? request.services.includes(value)
//           : request[column] === value
//       );
//     }

//     setFilteredRequests(filteredData);
//   };


//   const handleStatusFilterChange = (e) => {
//     const value = e.target.value;
//     if (value === 'All') {
//       setFilteredRequests(requests);
//     } else {
//       const filteredData = requests.filter((request) => request.status === value);
//       setFilteredRequests(filteredData);
//     }
//   };


//   // Delete request function
//   const handleDelete = async (index) => {
//     try {
//       const response = await fetch(`http://localhost:5000/delete-request/${index}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         setRequests((prevRequests) => prevRequests.filter((_, i) => i !== index));
//         setFilteredRequests((prevRequests) => prevRequests.filter((_, i) => i !== index));
//       } else {
//         alert('Error deleting request');
//       }
//     } catch (error) {
//       console.error('Error deleting request:', error);
//     }
//   };

//   const handleStatusChange = async (id, newStatus) => {
//     try {
//       const response = await fetch(`http://localhost:5000/update-status/${id}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ status: newStatus }),
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setRequests((prevRequests) =>
//           prevRequests.map((request) =>
//             request.id === id ? { ...request, status: newStatus } : request
//           )
//         );
//         setFilteredRequests((prevRequests) =>
//           prevRequests.map((request) =>
//             request.id === id ? { ...request, status: newStatus } : request
//           )
//         );
//         alert('Status updated successfully');
//       } else {
//         console.error('Failed to update status');
//       }
//     } catch (error) {
//       console.error('Error updating status:', error);
//     }
//   };





//   return (
//     <div className='sales-ctn'>
//       <div className="page-container">
//         <Navbar />
//         <div className="content-wrapper">
//           <SideMenu />
//           <div className="table-wrapper" style={{ background: "rgba( 0 , 0 , 0, .12" }}>
//             <h1>Welcome Sales Team !</h1> <br />
//             <table>
//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>Company Name</th>
//                   <th>Email</th>
//                   <th>Phone</th>
//                   <th>
//                     Contact Method
//                     <select
//                       onChange={(e) => handleFilterChange(e, 'contactMethod')}
//                       style={{ marginLeft: '10px' }}
//                     >
//                       <option value="All">All</option>
//                       <option value="Phone">Phone</option>
//                       <option value="Email">Email</option>
//                     </select>
//                   </th>
//                   <th>
//                     Services
//                     <select
//                       onChange={(e) => handleFilterChange(e, 'services')}
//                       style={{ marginLeft: '10px' }}
//                     >
//                       <option value="All">All</option>
//                       <option value="AI Services">AI Services</option>
//                       <option value="Web Development">Web Development</option>
//                       <option value="App Development">App Development</option>
//                       <option value="Cloud Services">Cloud Services</option>
//                     </select>
//                   </th>
//                   <th>Description</th>
//                   <th>Requirements</th>
//                   <th>Action</th>
//                   <th>Status

//                     <select
//                       onChange={handleStatusFilterChange} // Use the function here
//                       style={{ marginLeft: '10px' }}
//                     >
//                       <option value="All">All</option>
//                       <option value="In Process">In Process</option>
//                       <option value="Closed">Closed</option>
//                       <option value="Delivered">Delivered</option>
//                       <option value="Development on going">Development on going</option>
//                     </select>
//                   </th>


//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredRequests.map((request, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{request.companyName}</td>
//                     <td>{request.email}</td>
//                     <td>{request.phone}</td>
//                     <td>{request.contactMethod}</td>
//                     <td>{request.services}</td>
//                     <td>{request.description}</td>
//                     <td>
//                       {request.pdfFile ? (
//                         <a
//                           href={`http://localhost:5000/uploads/${request.pdfFile}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           Req. PDF
//                         </a>
//                       ) : (
//                         'No PDF'
//                       )}
//                     </td>
//                     <td>
//                       <button className="del-btn" onClick={() => handleDelete(index)}>
//                         Delete
//                       </button>
//                     </td>

//                     <td>
//                       <select
//                         value={request.status || ""}
//                         onChange={(e) => handleStatusChange(request.id, e.target.value)} >
//                         <option value="In Process">In Process</option>
//                         <option value="Closed">Closed</option>
//                         <option value="Delivered">Delivered</option>
//                         <option value="Development on going">Development on going</option>
//                       </select>
//                     </td>



//                   </tr>

//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//         <Footer />
//       </div>
//     </div>
//   );
// };

// export default SalesPage;



// RBAC

// import React, { useEffect, useState } from 'react';
// import Navbar from './Navbar';
// import Footer from './Footer';
// import SideMenu from './SideMenu';

// const SalesPage = () => {
//   const [requests, setRequests] = useState([]);
//   const [filteredRequests, setFilteredRequests] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchRequests = async () => {
//       try {
//         const response = await fetch('http://localhost:5000/get-requests');
//         const data = await response.json();
//         setRequests(data);
//         setFilteredRequests(data); // Initialize filteredRequests with all requests
//       } catch (error) {
//         console.error('Error fetching requests:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRequests();
//   }, []);

//   const handleFilterChange = (e, column) => {
//     const value = e.target.value;
//     let filteredData = [...requests];

//     if (value !== 'All') {
//       filteredData = filteredData.filter((request) =>
//         column === 'services'
//           ? request.services.includes(value)
//           : request[column] === value
//       );
//     }

//     setFilteredRequests(filteredData);
//   };

//   const handleStatusFilterChange = (e) => {
//     const value = e.target.value;
//     if (value === 'All') {
//       setFilteredRequests(requests);
//     } else {
//       const filteredData = requests.filter((request) => request.status === value);
//       setFilteredRequests(filteredData);
//     }
//   };

//   const handleDelete = async (index) => {
//     try {
//       const response = await fetch(`http://localhost:5000/delete-request/${index}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         setRequests((prevRequests) => prevRequests.filter((_, i) => i !== index));
//         setFilteredRequests((prevRequests) => prevRequests.filter((_, i) => i !== index));
//       } else {
//         alert('Error deleting request');
//       }
//     } catch (error) {
//       console.error('Error deleting request:', error);
//     }
//   };

//   const handleStatusChange = async (id, newStatus) => {
//     try {
//       const response = await fetch(`http://localhost:5000/update-status/${id}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ status: newStatus }),
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setRequests((prevRequests) =>
//           prevRequests.map((request) =>
//             request.id === id ? { ...request, status: newStatus } : request
//           )
//         );
//         setFilteredRequests((prevRequests) =>
//           prevRequests.map((request) =>
//             request.id === id ? { ...request, status: newStatus } : request
//           )
//         );
//         alert('Status updated successfully');
//       } else {
//         console.error('Failed to update status');
//       }
//     } catch (error) {
//       console.error('Error updating status:', error);
//     }
//   };

//   return (
//     <div className="sales-ctn">
//       <div className="page-container">
//         <Navbar />
//         <div className="content-wrapper">
//           <SideMenu />
//           <div className="table-wrapper" style={{ background: 'rgba(0, 0, 0, 0.12)' }}>
//             <h1>Welcome Sales Team!</h1>
//             <br />
//             <table>
//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>Company Name</th>
//                   <th>Email</th>
//                   <th>Phone</th>
//                   <th>
//                     Contact Method
//                     <select
//                       onChange={(e) => handleFilterChange(e, 'contactMethod')}
//                       style={{ marginLeft: '10px' }}
//                     >
//                       <option value="All">All</option>
//                       <option value="Phone">Phone</option>
//                       <option value="Email">Email</option>
//                     </select>
//                   </th>
//                   <th>
//                     Services
//                     <select
//                       onChange={(e) => handleFilterChange(e, 'services')}
//                       style={{ marginLeft: '10px' }}
//                     >
//                       <option value="All">All</option>
//                       <option value="AI Services">AI Services</option>
//                       <option value="Web Development">Web Development</option>
//                       <option value="App Development">App Development</option>
//                       <option value="Cloud Services">Cloud Services</option>
//                     </select>
//                   </th>
//                   <th>Description</th>
//                   <th>Requirements</th>
//                   <th>Action</th>
//                   <th>
//                     Status
//                     <select
//                       onChange={handleStatusFilterChange}
//                       style={{ marginLeft: '10px' }}
//                     >
//                       <option value="All">All</option>
//                       <option value="In Process">In Process</option>
//                       <option value="Closed">Closed</option>
//                       <option value="Delivered">Delivered</option>
//                       <option value="Development on going">Development on going</option>
//                       <option value="Future Prospect">Future Prospect</option>
//                     </select>
//                   </th>

//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan="10">Loading...</td>
//                   </tr>
//                 ) : (
//                   filteredRequests.map((request, index) => (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td>{request.companyName}</td>
//                       <td>{request.email}</td>
//                       <td>{request.phone}</td>
//                       <td>{request.contactMethod}</td>
//                       <td>{request.services}</td>
//                       <td>{request.description}</td>
//                       <td>
//                         {request.pdfFile ? (
//                           <a
//                             href={`http://localhost:5000/uploads/${request.pdfFile}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             Req. PDF
//                           </a>
//                         ) : (
//                           'No PDF'
//                         )}
//                       </td>
//                       <td>
//                         <button
//                           className="del-btn"
//                           onClick={() => handleDelete(index)}
//                         >
//                           Delete
//                         </button>
//                       </td>
//                       <td>
//                         <select
//                           value={request.status || ''}
//                           onChange={(e) =>
//                             handleStatusChange(request.id, e.target.value)
//                           }
//                         >
//                           <option value="In Process">In Process</option>
//                           <option value="Closed">Closed</option>
//                           <option value="Delivered">Delivered</option>
//                           <option value="Development on going">
//                             Development on going
//                           </option>
//                           <option value="Future Prospect">Future Prospect</option>
//                         </select>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//         <Footer />
//       </div>
//     </div>
//   );
// };

// export default SalesPage;








// notes


import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import SideMenu from './SideMenu';
import * as XLSX from 'xlsx'; // Import the XLSX library
import { FaDownload } from 'react-icons/fa'; // Import FontAwesome download icon

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SalesPage = () => {
  const [requests, setRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [note, setNote] = useState('');

  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  // const isAdmin = localStorage.getItem('role') ==='Admin';
  // const isTeam = localStorage.getItem('role') === 'Team';
  // const isAdminOrTeam = isAdmin || isTeam ;
  // console.log('isAdmin:' , isAdmin);

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/fetchservices`);
        const data = await response.json();
        setRequests(data);
        setFilteredRequests(data); // Initialize filteredRequests with all requests
      } catch (error) {
        console.error('Error fetching requests:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, []);


  const toggleExpandDescription = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const truncateText = (text, limit) => {
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  };

  const handleFilterChange = (e, column) => {
    const value = e.target.value;
    let filteredData = [...requests];

    if (value !== 'All') {
      filteredData = filteredData.filter((request) =>
        column === 'services'
          ? request.services.includes(value)
          : request[column] === value
      );
    }

    setFilteredRequests(filteredData);
  };

  const handleStatusFilterChange = (e) => {
    const value = e.target.value;
    if (value === 'All') {
      setFilteredRequests(requests);
    } else {
      const filteredData = requests.filter((request) => request.status === value);
      setFilteredRequests(filteredData);
    }
  };

  const handleDelete = async (index) => {
    try {
      const response = await fetch(`${API_BASE_URL}/delete-request/${index}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        setRequests((prevRequests) => prevRequests.filter((_, i) => i !== index));
        setFilteredRequests((prevRequests) => prevRequests.filter((_, i) => i !== index));
      } else {
        alert('Error deleting request');
      }
    } catch (error) {
      console.error('Error deleting request:', error);
    }
  };

  const handleStatusChange = async (email, newStatus) => {
    try {
      const response = await fetch(`${API_BASE_URL}/update-status/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email ,status: newStatus }),
      });

      if (response.ok) {
        setRequests((prevRequests) =>
          prevRequests.map((request) =>
            request.email === email ? { ...request, status: newStatus } : request
          )
        );
        setFilteredRequests((prevRequests) =>
          prevRequests.map((request) =>
            request.email === email ? { ...request, status: newStatus } : request
          )
        );
        alert('Status updated successfully');
      } else {
        console.error('Failed to update status');
      }
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  // Open note editor
  const openNoteEditor = (email) => {
    setEditingNoteId(email);
    const savedNotes = JSON.parse(localStorage.getItem('notes')) || {};
    setNote(savedNotes[email] || '');
  };

  // Save note to localStorage
  const saveNote = () => {
    const notes = JSON.parse(localStorage.getItem('notes')) || {};
    notes[editingNoteId] = note;
    localStorage.setItem('notes', JSON.stringify(notes));
    setEditingNoteId(null);
    alert('Note saved successfully!');
  };


  // Export table data to Excel
  const exportToExcel = () => {
    const exportData = filteredRequests.map((request , index) => ({
      'ID':request.id || index + 1,
      'Company Name': request.company_name,
      'Email': request.email,
      'Phone': request.phone,
      'Contact Method': request.contact_method,
      'Services': request.services,
      'Description': request.description,
      'Status': request.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sales Data');

    // Save the file
    XLSX.writeFile(workbook, 'sales_data.xlsx');
  };



  return (
    <div className="sales-ctn">
      <div className="page-container">
        <Navbar />
        <div className="content-wrapper">
          <SideMenu />
          <div className="table-wrapper" >
            <h1 style={{position:'absolute'}}>Welcome Admin!</h1>

             {/* Download Button */}
             <div className='download-btn'>
             <FaDownload
                onClick={exportToExcel}
                style={{
                  cursor: 'pointer',
                  fontSize: '20px',
                  color: 'black',
                }}
                title="Download Excel"
              />           
            </div>

            
            <br />
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  {/* {(isAdmin || isTeam )&& <th>Company Name</th> }
                  {(isAdmin || isTeam )&& <th>Email</th>}
                  {(isAdmin || isTeam) && <th>Phone</th>} */}
                  <th>Company Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>
                    Contact Method
                    <select
                      onChange={(e) => handleFilterChange(e, 'contactMethod')}
                      style={{ marginLeft: '10px' }}
                    >
                      <option value="All">All</option>
                      <option value="Phone">Phone</option>
                      <option value="Email">Email</option>
                    </select>
                  </th>
                  <th>
                    Services
                    <select
                      onChange={(e) => handleFilterChange(e, 'services')}
                      style={{ marginLeft: '10px' }}
                    >
                      <option value="All">All</option>
                      <option value="AI Services">AI Services</option>
                      <option value="Web Development">Web Development</option>
                      <option value="App Development">App Development</option>
                      <option value="Cloud Services">Cloud Services</option>
                    </select>
                  </th>
                  <th className='description'>Description</th>
                 {/* {(isAdmin || isTeam) && <th>Requirements</th> } */}
                 <th>Requirements</th>
                  <th>Notes</th>
                  <th>Action</th>
                  {/* {isAdmin && <th>Action</th>  } */}

                  <th>
                    Status
                    <select
                      onChange={handleStatusFilterChange}
                      style={{ marginLeft: '10px' }}
                    >
                      <option value="All">All</option>
                      <option value="In Process">In Process</option>
                      <option value="Closed">Closed</option>
                      <option value="Delivered">Delivered</option>
                      <option value="Development on going">Development on going</option>
                      <option value="Future Prospect">Future Prospect</option>
                    </select>
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="11">Loading...</td>
                  </tr>
                ) : (
                  filteredRequests.map((request, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {/* {(isAdmin || isTeam ) && ( <td>{request.companyName}</td> )}
                      {(isAdmin || isTeam)&& ( <td>{request.email}</td> )}
                      {(isAdmin || isTeam ) && ( <td>{request.phone}</td> )} */}

                      <td>{request.company_name}</td>
                      <td>{request.email}</td>
                      <td>{request.phone}</td>
                      <td>{request.contact_method}</td>
                      <td>{request.services}</td>
                      {/* <td>
                        <div className='description'>{request.description}</div>
                      </td> */}


                      <td>
                      <div className='description'>
                        {expandedDescriptions[request.id]
                          ? request.description
                          : truncateText(request.description, 150)}
                        {request.description.length > 200 && (
                          <button
                            onClick={() => toggleExpandDescription(request.id)}
                            style={{
                              marginLeft: '10px',
                              background: 'none',
                              color: 'blue',
                              border: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            {expandedDescriptions[request.id]
                              ? 'Read Less'
                              : 'Read More'}
                          </button>
                        )}
                        </div>
                      </td>

                      {/* {(isAdmin || isTeam) && ( */}
                      <td>
                        {request.pdf_link ? (
                          <a
                            href={`${request.pdf_link}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Req. PDF
                          </a>
                        ) : (
                          'No PDF'
                        )}
                      </td>
                      {/* )} */}
                      <td>
                        <div className='edt' onClick={() => openNoteEditor(request.email)}>
                        <img src='/class-notes.png' alt='Notes' />
                        <p>{
                          JSON.parse(localStorage.getItem('notes'))?.[request.email] ||
                          'No Notes Available'
                        }</p>
                        </div>
                       
                      </td>
                      {/* {isAdmin && ( */}
                      <td>
                        <div
                          className="del"
                          onClick={() => handleDelete(index)}
                        >
                         <img  src='/delete.png' alt='Delete'/>
                        </div>
                      </td>
                      {/* // )} */}
                      <td>
                      {/* {isAdminOrTeam ? ( */}
                        <select
                          value={request.status || ''}
                          onChange={(e) =>
                            handleStatusChange(request.email, e.target.value)
                          }
                        >
                          <option value="In Process">In Process</option>
                          <option value="Closed">Closed</option>
                          <option value="Delivered">Delivered</option>
                          <option value="Development on going">
                            Development on going
                          </option>
                          <option value="Future Prospect">Future Prospect</option>
                        </select>
                      {/* ) : ( */}
                        {/* <span>{request.status || 'No Status'} </span> */}
                      {/* )}  */}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        {editingNoteId && (
          <div className="modal">
            <div className="modal-content">
              <h2>Edit Note</h2>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Add or edit your note here"
                rows={5}
              />
              <div className='modalbtn'>
              <button onClick={saveNote}>Save</button>
              <button onClick={() => setEditingNoteId(null)}>Cancel</button>
              </div>
            </div>
          </div>
        )}
        <Footer />
      </div>
    </div>
  );
};

export default SalesPage;
